<section id="content" *ngIf="lang">
  <div class="page page-profile">

    <!-- page header -->
    <div class="pageheader">
      <h2>{{ lang?.audit }}</h2>
      <div class="page-bar">
        <ul class="page-breadcrumb">
          <li>
            <a [routerLink]="'/'+AppFrontRoutes.DASHBOARD"><i class="fa fa-home"></i>
              {{AppSettings.SITE_TITLE | titlecase}}</a>
          </li>
          <li>
            <a [routerLink]="'/'+AppFrontRoutes.Servicing_List">{{ lang?.audit }}</a>
          </li>
        </ul>
        <div class="social-icons" style="margin-bottom: 0px;float: right;"><a (click)="addStandard()"
            class="plus-add overwrite_write"><i class="fa fa-plus"></i></a></div>
      </div>
    </div>

    <div class="pagecontent">
      <div class="row">
        <div class="col-md-12">
          <div class="tile tile-simple">
            <div class="standard-page">
              <!-- <div class="cpy_pst sameshow mblsameshow tabular_operations1 value_top1">
                  <a (click)="addStandard()" class="mar-rt-5 common-newicons icon-colors4 standard_action export_new" data-action="add_standard" data-id="">
                      <span class="glyphicon glyphicon-plus"></span>
                  </a>
              </div> -->

              <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef>
                    <span> Clause </span>
                  </th>
                  <td mat-cell *matCellDef="let data" style="width: 85%;">
                    <button mat-icon-button [style.visibility]="!data.expandable ? 'hidden' : ''"
                      [style.marginLeft.px]="data.level * 32" (click)="treeControl.toggle(data)">
                      <mat-icon class="mat-icon-rtl-mirror">
                        {{treeControl.isExpanded(data) ? 'expand_more' : 'chevron_right'}}
                      </mat-icon>
                    </button>
                    <i style="font-size: 24px;padding: 0px 20px;" class="fa fa-folder-open" aria-hidden="true"></i>
                    {{data.name}}
                  </td>
                </ng-container>

                <ng-container matColumnDef="count">
                  <th mat-header-cell *matHeaderCellDef> Value </th>
                  <td mat-cell *matCellDef="let data"> {{data.count}} </td>
                </ng-container>
                <ng-container matColumnDef="action">
                  <th mat-header-cell *matHeaderCellDef> Action </th>
                  <td mat-cell *matCellDef="let data">
                    <!-- Action Values -->
                    <div class="standard-values">
                      <div>
                        <p class="quality-col4"><a (click)="editStandard(data)"
                            class="common-newicons icon-colors1 standard_action " title="Edit" style="float:left;"
                            data-action="add_standard" data-id="1" style="display: inline-block;">
                            <span class="glyphicon glyphicon-edit"></span>
                          </a>
                          <a href="javascript:void(0);" (click)="deleteStandard(data)" class="common-newicons icon-colors3 standard_action "
                            title="Delete" style="float:left;" data-action="delete_standard" data-id="1"
                            style="display: inline-block;">
                            <span class="glyphicon glyphicon-trash"></span>
                          </a>
                          <span class="hor_bar" *ngIf="data?.level < 2">
                            <span>
                              <a href="javascript:void(0);" (click)="addChapter(data)" class="common-newicons icon-colors4 chapter_action "
                                title="Add" data-action="add_chapter" data-id="" style="display: inline-block;">
                                <span class="glyphicon glyphicon-plus"></span>
                              </a>
                            </span>
                          </span>
                        </p>
                      </div>
                    </div>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>


              </table>

            </div>
          </div>
        </div>
      </div>
    </div>



  </div>
</section>